import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar/Sidebar";
import Statistics from "../../components/Statistics/Statistics";
import "./Dashboard.css";
import { AuthContext } from "../../context/Authcontext";
import { sectionViewPermission } from "../../utils/permissions";
import { NavIcon, pathFor, visibleGroups } from "../../components/Sidebar/navigation";

const greeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return "Goedemorgen";
  if (hour < 18) return "Goedemiddag";
  return "Goedenavond";
};

export default function Dashboard() {
  const { user, loading, can } = React.useContext(AuthContext);
  const navigate = useNavigate();

  if (loading) {
    return <div className="dashboard-container">Laden...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  const groups = visibleGroups((key) => can(sectionViewPermission(key)));
  const today = new Date().toLocaleDateString("nl-NL", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

  return (
    <div className="dashboard-container">
      <Sidebar />
      <main className="dashboard-content">
        <header className="dashboard-hero">
          <div>
            <p className="dashboard-date">{today}</p>
            <h1>{greeting()}, {user?.firstName || "beheerder"}</h1>
            <p className="dashboard-intro">
              Beheer inhoud, gebruikers en instellingen van de MyDharma app vanuit één plek.
            </p>
          </div>
          <span className="dashboard-role">{user?.role === "admin" ? "Admin" : (user?.roleName || "Medewerker")}</span>
        </header>

        {groups.map((group) => (
          <section key={group.key} className="quick-group">
            <h2>{group.label}</h2>
            <div className="quick-grid">
              {group.items.map((item) => (
                <button key={item.key} type="button" className="quick-card" onClick={() => navigate(pathFor(item.key))}>
                  <NavIcon item={item} className="quick-icon" />
                  <span>{item.label}</span>
                </button>
              ))}
            </div>
          </section>
        ))}

        {can("stats.view") && (
          <section className="quick-group">
            <h2>Statistieken</h2>
            <Statistics />
          </section>
        )}
      </main>
    </div>
  );
}
